export default __webpack_public_path__ + "static/media/competence-colored.0dfcc10d.svg";